import NestedRouteComponent from 'router/nestedViews/NestedRouteComponent';
import wrapLegacyRoute from 'router/legacy/wrapLegacyRoute';
import translation from 'translation';

const accountAdvertisersRoutes = [
  {
    path: 'advertisers',
    component: NestedRouteComponent,
    meta: {
      routeName: {
        segmentName: () => translation.tr('Advertisers')
      },
      permissions: ['READ_ADVERTISERS']
    },
    children: [
      {
        path: '',
        name: 'advertisersList',
        component: wrapLegacyRoute('advertisersController', 'list')
      },
      {
        path: 'create',
        name: 'advertiserCreate',
        component: wrapLegacyRoute('advertisersController', 'create')
      },
      {
        path: ':advertiserId(\\d+)',
        name: 'advertisersDetails',
        component: wrapLegacyRoute('advertisersController', 'details')
      }
    ]
  }
];

export default accountAdvertisersRoutes;
